import { TDomainInterpretation, TSubdomainInterpretation } from '@/types/Health.types';
import { api } from '..';
import { apiPaths } from '@/services/api/paths';

export const domainInterpretationGet = async (domain: string): Promise<TDomainInterpretation> => {
  const { data } = await api.get(apiPaths.screener.domainInterpretation(domain));

  return data.data;
};

export const subdomainInterpretationGet = async (
  domain: string,
  subdomain: string,
): Promise<TSubdomainInterpretation> => {
  const { data } = await api.get(apiPaths.screener.subdomainInterpretation(domain, subdomain));

  return data.data;
};
